import React from 'react';
import './Button.scss';
import { Icon } from 'react-feather';

interface ButtonProps {
  label: string;
  icon?: any;
  iconPosition?: 'start' | 'end';
  buttonStyle?: 'regular' | 'action' | 'alert' | 'red-round';
  disabled?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  iconOnly?: boolean;
}

export function Button({
  label,
  icon: Icon,
  iconPosition = 'start',
  buttonStyle = 'regular',
  disabled = false,
  onClick,
  style,
  iconOnly = false,
  ...props
}: ButtonProps) {
  return (
    <button
      className={`button ${buttonStyle} ${disabled ? 'disabled' : ''} ${iconOnly ? 'icon-only' : ''}`}
      onClick={onClick}
      style={style}
      disabled={disabled}
      {...props}
    >
      {Icon && iconPosition === 'start' && <Icon size={16} />}
      <span className={iconOnly ? 'sr-only' : ''}>{label}</span>
      {Icon && iconPosition === 'end' && <Icon size={16} />}
    </button>
  )
}
